import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import coverSrc from 'assets/img/generic/4.jpg';
import Flex from 'components/common/Flex';
import VerifiedBadge from 'components/common/VerifiedBadge';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import ProfileBanner from './ProfileBanner';
import ModalSolicitarVacaciones from './ModalSolicitarVacaciones';

const Banner = ({ perfil, setShowModalFoto, imagenPerfil, onVacationUpdate }) => {
    const { idUsuario, token } = useToken();
    const { id } = useParams();
    const { showErrorToast, showSuccessToast } = useToast();
    const [showModalVacaciones, setShowModalVacaciones] = useState(false);
    const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' });
    const [selectedDaysList, setSelectedDaysList] = useState([]);
    const [saving, setSaving] = useState(false);
    const [calculoVacaciones, setCalculoVacaciones] = useState({
        diasTotales: 0,
        diasUtilizados: 0,
        diasDisponibles: 0,
        aniosServicio: 0,
        desglosePorAnio: []
    });

    const loadCalculoVacaciones = async () => {
        try {
            const response = await fetch(`/api/vacaciones/CalcularDiasVacacionesLFT?idUsuario=${perfil.idUsuario}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const resumen = detalles.table2?.[0] || detalles.Table2?.[0];
                const desglose = detalles.table3 || detalles.Table3 || [];

                if (resumen) {
                    setCalculoVacaciones({
                        diasTotales: resumen.iDiasTotalesAcumulados || 0,
                        diasUtilizados: resumen.iDiasUtilizados || 0,
                        diasDisponibles: resumen.iDiasDisponibles || 0,
                        aniosServicio: resumen.iAniosServicio || 0,
                        proximoAniversario: resumen.dProximoAniversario || null,
                        diasHastaProximoAniversario: resumen.iDiasHastaProximoAniversario || 0,
                        estadoAniosServicio: resumen.vEstadoAniosServicio || '',
                        desglosePorAnio: Array.isArray(desglose) ? desglose.map(d => ({
                            iAnio: d.iAnio || 0,
                            vDescripcionAnio: d.vDescripcionAnio || `Año ${d.iAnio}`,
                            dFechaInicio: d.dFechaInicio || '',
                            dFechaFin: d.dFechaFin || '',
                            iDiasGenerados: d.iDiasGenerados || 0,
                            iDiasUtilizados: d.iDiasUtilizados || 0,
                            iDiasDisponibles: d.iDiasDisponibles || 0,
                            bPeriodoActivo: d.bPeriodoActivo || false,
                            bPeriodoCompletado: d.bPeriodoCompletado || false,
                            decPorcentajeAvance: d.decPorcentajeAvance || 0,
                            vEstadoPeriodo: d.vEstadoPeriodo || 'Desconocido'
                        })) : []
                    });
                }
            }

        } catch (error) {
            console.error('Error al cargar cálculo de vacaciones:', error);
        }
    };

    const requestVacation = async (motivo = '') => {
        setSaving(true);
        try {
            if (!selectedDaysList || selectedDaysList.length === 0) {
                throw new Error('Debes seleccionar al menos un día para solicitar vacaciones');
            }

            const fechasSolicitadas = selectedDaysList.map(day => day.dateString);
            const requestBody = {
                solicitud: {
                    idUsuario: perfil.idUsuario.toString(),
                    fechasSolicitadas: fechasSolicitadas,
                    vMotivoSolicitud: motivo ? motivo.trim() : ""
                }
            };

            const response = await fetch("/api/vacaciones/SolicitarVacaciones", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            if (data.iResponseType === 1) {
                setSelectedDates({ startDate: '', endDate: '' });
                setSelectedDaysList([]);
                setShowModalVacaciones(false);
                showSuccessToast(data.vMessage || 'Solicitud de vacaciones enviada exitosamente');
                loadCalculoVacaciones();
                if (onVacationUpdate) {
                    onVacationUpdate();
                }

            } else {
                throw new Error(data.vMessage || 'Error al procesar la solicitud de vacaciones');
            }

        } catch (error) {
            showErrorToast('Error al procesar la solicitud: ' + error.message);
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        if (perfil && perfil.idUsuario) {
            loadCalculoVacaciones();
        }
    }, [perfil]);

    return (
        <>
            <ProfileBanner>
                <ProfileBanner.Header
                    imagenPerfil={imagenPerfil}
                    coverSrc={coverSrc}
                />
                <ProfileBanner.Body>
                    <Row className="align-items-start g-3">
                        <Col xs={12} md={6} lg={8}>
                            {(idUsuario == perfil?.idUsuario || !id) && (
                                <Button
                                    type="button"
                                    variant="primary"
                                    className="mb-2"
                                    onClick={() => setShowModalFoto(true)}
                                >
                                    <FontAwesomeIcon icon="edit" className="me-2" />
                                    Cambiar foto
                                </Button>
                            )}
                            <h5 className="text-dark d-flex align-items-center gap-2">
                                @{perfil.vUsuario}
                            </h5>
                            <h4 className="mb-1 fw-bold text-dark d-flex align-items-center gap-2">
                                {perfil.vNombre} {perfil.vApellidos}<VerifiedBadge />
                            </h4>
                            <div className="mb-3">
                                <span className="text-dark fs--1 px-2 py-1 rounded-pill fw-medium">
                                    {perfil.vNombreTipoUsuario}
                                </span>
                            </div>
                            <p className="text-600 fs--1 mb-2 d-flex align-items-center">
                                <FontAwesomeIcon icon="map-marker-alt" className="me-2 text-500" />
                                {perfil.vDomicilioPersonal || 'No especificado'}
                            </p>
                            <p className="text-600 fs--1 mb-0 d-flex align-items-center">
                                <img src="/img/whatsapp40.png" width={18} className="me-2" alt="whatsapp" />
                                {perfil.vDatosContactoPersonal || 'Sin WhatsApp'}
                            </p>
                        </Col>
                        <Col xs={12} md={6} lg={4} className="border-start-md ps-md-4">
                            <div className="d-flex flex-column gap-2">
                                <Flex alignItems="center" className="mb-2">
                                    <FontAwesomeIcon
                                        icon="user-circle"
                                        className="me-2 text-700"
                                        style={{ height: '30px', width: '30px' }}
                                    />
                                    <div className="flex-1">
                                        <h6 className="mb-0">{perfil.vCURP}</h6>
                                    </div>
                                </Flex>
                                <Flex alignItems="center" className="mb-2">
                                    <img
                                        src="/img/cumple48.png"
                                        width={30}
                                        className="me-2"
                                        alt="cumpleaños"
                                    />
                                    <div className="flex-1">
                                        <h6 className="mb-0">{perfil.dFechaNacimiento}</h6>
                                    </div>
                                </Flex>

                                <Flex alignItems="center" className="mb-2">
                                    <img
                                        src="/img/telefono48.png"
                                        width={30}
                                        className="me-2"
                                        alt="teléfono"
                                    />
                                    <div className="flex-1">
                                        <h6 className="mb-0">{perfil.vTelefonoTrabajo}</h6>
                                    </div>
                                </Flex>
                                <Flex alignItems="center" className="mb-2">
                                    <img
                                        src="/img/email48.png"
                                        width={30}
                                        className="me-2"
                                        alt="email"
                                    />
                                    <div className="flex-1">
                                        <h6 className="mb-0">{perfil.vEmailTrabajo}</h6>
                                    </div>
                                </Flex>
                            </div>
                            <div className="mt-3 d-flex align-items-center gap-4">
                                {
                                    calculoVacaciones.diasDisponibles > 0 ?
                                        <Button
                                            type="button"
                                            size="sm"
                                            className="px-2"
                                            onClick={() => {
                                                setSelectedDates({ startDate: '', endDate: '' });
                                                setSelectedDaysList([]);
                                                setShowModalVacaciones(true);
                                            }}
                                            style={{
                                                backgroundColor: '#87CEEB',
                                                borderColor: '#87CEEB',
                                                color: '#2C5F7F',
                                                fontWeight: '500',
                                            }}

                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#6BB6D8';
                                                e.currentTarget.style.borderColor = '#6BB6D8';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#87CEEB';
                                                e.currentTarget.style.borderColor = '#87CEEB';
                                            }}

                                        > Solicitar Vacaciones
                                        </Button>
                                        :
                                        <>
                                            <Button
                                                type="button"
                                                size="sm"
                                                className="px-2"
                                                style={{
                                                    backgroundColor: '#87CEEB',
                                                    borderColor: '#87CEEB',
                                                    color: '#2C5F7F',
                                                    fontWeight: '500',
                                                }}
                                            > Solicitar Vacaciones
                                            </Button>
                                        </>
                                }

                                <div
                                    className="d-flex align-items-center py-1 px-2 rounded"
                                    style={{
                                        backgroundColor: calculoVacaciones.diasDisponibles > 0 ? '#E8F5E9' : '#F5F5F5',
                                        cursor: 'default'
                                    }}>
                                    <FontAwesomeIcon
                                        icon="calendar-check"
                                        className="me-1"
                                        style={{
                                            color: calculoVacaciones.diasDisponibles > 0 ? '#66BB6A' : '#9E9E9E',
                                            fontSize: '0.80rem'
                                        }} />
                                    <span
                                        style={{
                                            color: calculoVacaciones.diasDisponibles > 0 ? '#2E7D32' : '#757575',
                                            fontWeight: '600',
                                            fontSize: '0.80rem',
                                        }}
                                    >
                                        {calculoVacaciones.diasDisponibles} {calculoVacaciones.diasDisponibles === 1 ? 'día' : 'días'}
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </ProfileBanner.Body>
            </ProfileBanner>
            <ModalSolicitarVacaciones
                show={showModalVacaciones}
                onHide={() => setShowModalVacaciones(false)}
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                selectedDaysList={selectedDaysList}
                setSelectedDaysList={setSelectedDaysList}
                calculoVacaciones={calculoVacaciones}
                requestVacation={requestVacation}
                saving={saving}
            />
        </>
    );
};

Banner.propTypes = {
    perfil: PropTypes.object,
    setShowModalFoto: PropTypes.func,
    imagenPerfil: PropTypes.string,
    onVacationUpdate: PropTypes.func
};



export default Banner;